function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.023 16.8995H18.4571C17.7835 16.8995 17.3344 17.3486 17.3344 18.0222V43.8442C17.3344 44.5178 17.7835 44.9669 18.4571 44.9669H37.5429C38.2165 44.9669 38.6656 44.5178 38.6656 43.8442V18.0222C38.6656 17.3486 38.2165 16.8995 37.5429 16.8995H34.1748",
  stroke: "#C6AA92",
  strokeWidth: 2
});

var _ref3 = /*#__PURE__*/React.createElement("mask", {
  id: "path-2-outside-1_1429_1989",
  maskUnits: "userSpaceOnUse",
  x: 19.8252,
  y: 10.4087,
  width: 17,
  height: 12,
  fill: "black"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "white",
  x: 19.8252,
  y: 10.4087,
  width: 17,
  height: 12
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M29.5882 14.6541C29.6503 14.4785 29.684 14.2896 29.684 14.0928C29.684 13.1627 28.9301 12.4087 28 12.4087C27.0699 12.4087 26.316 13.1627 26.316 14.0928C26.316 14.2896 26.3497 14.4785 26.4118 14.6541H22.8252C22.2729 14.6541 21.8252 15.1018 21.8252 15.6541V19.2676C21.8252 19.8199 22.2729 20.2676 22.8252 20.2676H33.1748C33.7271 20.2676 34.1748 19.8199 34.1748 19.2676V15.6541C34.1748 15.1018 33.7271 14.6541 33.1748 14.6541H29.5882Z"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M29.5882 14.6541L27.7025 13.9876L26.7601 16.6541H29.5882V14.6541ZM26.4118 14.6541V16.6541H29.2399L28.2975 13.9876L26.4118 14.6541ZM27.684 14.0928C27.684 14.0594 27.69 14.0231 27.7025 13.9876L31.4739 15.3206C31.6106 14.9339 31.684 14.5198 31.684 14.0928H27.684ZM28 14.4087C27.8255 14.4087 27.684 14.2673 27.684 14.0928H31.684C31.684 12.0581 30.0346 10.4087 28 10.4087V14.4087ZM28.316 14.0928C28.316 14.2673 28.1745 14.4087 28 14.4087V10.4087C25.9654 10.4087 24.316 12.0581 24.316 14.0928H28.316ZM28.2975 13.9876C28.31 14.0231 28.316 14.0594 28.316 14.0928H24.316C24.316 14.5198 24.3894 14.9339 24.5261 15.3206L28.2975 13.9876ZM22.8252 16.6541H26.4118V12.6541H22.8252V16.6541ZM23.8252 15.6541C23.8252 16.2064 23.3775 16.6541 22.8252 16.6541V12.6541C21.1683 12.6541 19.8252 13.9973 19.8252 15.6541H23.8252ZM23.8252 19.2676V15.6541H19.8252V19.2676H23.8252ZM22.8252 18.2676C23.3775 18.2676 23.8252 18.7153 23.8252 19.2676H19.8252C19.8252 20.9244 21.1683 22.2676 22.8252 22.2676V18.2676ZM33.1748 18.2676H22.8252V22.2676H33.1748V18.2676ZM32.1748 19.2676C32.1748 18.7153 32.6225 18.2676 33.1748 18.2676V22.2676C34.8317 22.2676 36.1748 20.9244 36.1748 19.2676H32.1748ZM32.1748 15.6541V19.2676H36.1748V15.6541H32.1748ZM33.1748 16.6541C32.6225 16.6541 32.1748 16.2064 32.1748 15.6541H36.1748C36.1748 13.9973 34.8317 12.6541 33.1748 12.6541V16.6541ZM29.5882 16.6541H33.1748V12.6541H29.5882V16.6541Z",
  fill: "#BBBBBB",
  mask: "url(#path-2-outside-1_1429_1989)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M22.1395 31.6437L26.6377 35.8506L33.8605 25.432",
  stroke: "#92CB54",
  strokeWidth: 2,
  strokeLinejoin: "round"
});

function SvgMaintenance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenance);
export default __webpack_public_path__ + "static/media/Maintenance.cf2c8b27.svg";
export { ForwardRef as ReactComponent };